module.exports = __webpack_public_path__ + "img/deepseek-ico.bfef54b0.svg";